import { render, staticRenderFns } from "./AAsignacionProgMktV2.vue?vue&type=template&id=6fa97346&scoped=true"
import script from "./AAsignacionProgMktV2.vue?vue&type=script&lang=js"
export * from "./AAsignacionProgMktV2.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionProgMktV2.vue?vue&type=style&index=0&id=6fa97346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa97346",
  null
  
)

export default component.exports